export enum AttributeTypeEnum {
    TEXT = "text",
    INT = "int",
    DATE = "date",
    DECIMAL = "decimal",
    TIME = "time",
    TIMESTAMP = "timestamp",
    VALUE_LIST = "value list",
    JSON = "json",
    INCREMENTING = "incrementing",
    LOOKUP = "lookup",
    EMAIL = "email",
    TAGS = "tasg",
    BOOLEAN = "boolean"
}



// WEBPACK FOOTER //
// ./app/components/bo-core/enums/AttributeTypeEnum.ts